import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { Subject } from "rxjs";

@Component({
    selector: 'app-proporciones-envase-component',
    templateUrl: './proporciones-envase.component.html'
})
export class ProporcionesEnvaseComponent implements OnInit {

    public porcionesForm: UntypedFormGroup;
    public showError = false;
    public _edtiable: boolean;

    public sumaKilos;
    public porcionesEnvase;

    public envasesId;

    public allDenominaciones;

    public disabledEnvases: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();

    get editable(): boolean {return this._edtiable; }
    @Input() set editable(value: boolean) {
        this._edtiable = value;
        if (this.porcionesForm) {
            if (value) {
                this.porcionesForm.enable();
            } else {
                this.porcionesForm.disable();
                this.disabledEnvases.next(true);
                this.disabledDenominaciones.next(true);
                this.porcionesForm.patchValue({
                    envase: this.envases.find(x => x.des === this.porcion.desEnvase),
                    denominacion:  this.denominaciones.find(x => x.id === this.porcion.denominacionId),
                    kilos: this.porcion.kilos
                });
            }
        }
    }

    @Input() denominaciones;
    @Input() envases;
    @Input() porciones?;
    @Input() porcion?;

    @Output() refreshAdd = new EventEmitter<any>();
    @Output() refreshRemove = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
    ) {}

    ngOnInit() {
        this.allDenominaciones = this.denominaciones.filter(x => x.id !== null);

        this.porcionesForm = this._fb.group({
            envase: [{ value: '', disabled: !this.editable }, Validators.required],
            denominacion: [{ value: '', disabled: !this.editable }, Validators.required],
            kilos: ['', Validators.required]
        });

        if (this.porcion) {
            this.porcionesForm.disable();
            this.disabledEnvases.next(true);
            this.disabledDenominaciones.next(true);
            this.porcionesForm.patchValue({
                envase: this.envases.find(x => x.des === this.porcion.desEnvase),
                denominacion:  this.denominaciones.find(x => x.id === this.porcion.denominacionId),
                kilos: this.porcion.kilos
            });
        }
    }

    public save() {
        this.checkForm();
        if (this.porcionesForm.valid) {
            const _porcion = {
                envaseIdTabla: this.porcionesForm.get('envase').value.idTabla,
                envase: this.porcionesForm.get('envase').value.id,
                desEnvase: this.porcionesForm.get('envase').value.des,
                denominacionId: this.porcionesForm.get('denominacion').value.id,
                disenyoEtiquetasIdCaja: this.porcionesForm.get('denominacion').value.disenyoEtiquetasIdCaja,
                disenyoEtiquetasIdPallet: this.porcionesForm.get('denominacion').value.disenyoEtiquetasIdPallet,
                kilos: this.porcionesForm.get('kilos').value,
                porcionesEnEnvase: 1,
            };
            this.checkKilos(_porcion);
        }
    }

    private checkKilos(porcion) {
        this.sumaKilos = Number(porcion.kilos);
        const envase = this.envases.find(x => x.des === porcion.desEnvase);
        this.porcionesEnvase = this.porciones.filter(x => x.desEnvase === porcion.desEnvase);
        if (this.porcionesEnvase.length > 0) {
            for (let porcionEnvase of this.porcionesEnvase) {
                this.sumaKilos += Number(porcionEnvase.kilos);
            }
        }

        if (this.sumaKilos > (envase.peso)) {
            this.refreshAdd.emit();
        } else {
            this.refreshAdd.emit(porcion);
            this.porcionesForm.disable();
            this.disabledEnvases.next(true);
            this.disabledDenominaciones.next(true);
        }
    }

    public remove() {
        this.refreshRemove.emit(this.porcion);
    }

    public cancel() {
        if (!this.porcion) {
            this.close.emit(false);
        }
    }

    private checkForm() {
        this.showError = this.porcionesForm.invalid;
    }
}
